import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import Icon from '../Icon/Icon'

/**
 * Map from status types to icons.
 */
const ICONS = {
  info: 'information-circled',
  warning: 'warning',
  alert: 'alert',
  error: 'alert',
  success: 'checkmark-circled',
}

/**
 * A message component relays information to the user. It can be a basic
 * information message, an error message, a warning, or indication of an action
 * being completed successfully.
 */
export default function Message({ children, className, size, type, ariaLive }) {
  return (
    <div className={cn('c-message', `c-message--${type}`, className)}>
      <Icon
        icon={ICONS[type]}
        size={size}
        type={type}
        className="c-message__icon"
      />
      <div className="c-message__body" aria-live={ariaLive}>
        {children}
      </div>
    </div>
  )
}

Message.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf(['small', 'large']),
  type: PropTypes.oneOf(['alert', 'info', 'warning', 'error', 'success'])
    .isRequired,
  ariaLive: PropTypes.string,
}

Message.defaultProps = {
  className: '',
  ariaLive: 'polite',
  size: null,
}
